export enum APP_TYPE {
    TOOLS = "tools",
    KONSULT = "konsult",
}